import React, { useEffect, useState, useCallback } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Link } from "react-router-dom";
import TripServices from "../services/externalServices/tripServices";
import { useDispatch, useSelector } from "react-redux";

const OnGoingTrip = React.memo(() => {
  const dispatch = useDispatch();
  const {serviceType} = useSelector((state) => state.serviceType.serviceType);
  const [recentTrips, setRecentTrips] = useState([]);

  const getRecentTrips = useCallback(async () => {
    try {
      const response = await TripServices.getTripswithRiders(serviceType);
      const trips = response.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      const lastThreeTrips = trips.slice(0, 3);
      setRecentTrips(lastThreeTrips);
      console.log("recent trips===========", lastThreeTrips);
    } catch (error) {
      console.error("Error fetching recent trips:", error);
    }
  }, [serviceType]);

  useEffect(() => {
    getRecentTrips();
  }, [serviceType]);

  return (
    <Card sx={{ maxWidth: "auto", margin: "auto" }}>
      <CardContent>
        <Typography variant="h6" component="div" gutterBottom>
          Recent Trips
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Trip</TableCell>
                <TableCell>User Name</TableCell>
                <TableCell>Driver Name</TableCell>
                <TableCell>Pickup Location</TableCell>
                <TableCell>Drop Location</TableCell>
              </TableRow>
            </TableHead>
            {recentTrips && (
              <TableBody>
                {recentTrips.map((trip, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Link
                        to={`/trip/${trip._id}`}
                        className="text-decoration-none text-dark font-weight-bold"
                      >
                        {trip._id}
                      </Link>
                    </TableCell>
                    <TableCell>{trip.userDetails[0]?.first_name} {trip.userDetails[0]?.last_name}</TableCell>
                    <TableCell>{trip.riderDetails[0]?.first_name} {trip.riderDetails[0]?.last_name}</TableCell>
                    <TableCell>
                      {trip.cabRequestDetails[0]?.pickup_location?.title}
                    </TableCell>
                    <TableCell>
                      {trip.cabRequestDetails[0]?.drop_location?.title}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
});

export default OnGoingTrip;
